import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import BaseAnchor from "../Anchor/BaseAnchor";
import { IconChevronRight16 } from "../Icons/Icons";
import Badge from "../Badge/Badge";

const VerticalNavItem = ({
  id,
  icon,
  text,
  to,
  onClick,
  isActive,
  hasSubMenu,
  className,
  notifications,
  tabIndex,
}) => {
  const buttonClasses = classNames("vertical-nav__item-btn", {
    "is-active": isActive,
    "has-children": hasSubMenu,
  });

  const listItemClass = `vertical-nav__list-item ${className}`;

  return (
    <li
      className={listItemClass}
      role="menuitem"
      id={`${id}-link`}
      onTransitionEnd={e => e.stopPropagation()}
    >
      <BaseAnchor className={buttonClasses} to={to} onClick={onClick} tabIndex={tabIndex}>
        <span className="vertical-nav__item-btn-inner">
          {icon && icon}
          <span className="vertical-nav__item-text">{text}</span>
        </span>
        {hasSubMenu && <IconChevronRight16 className="vertical-nav__arrow-icon" />}
        {notifications > 0 && <Badge number={notifications} />}
      </BaseAnchor>
    </li>
  );
};

VerticalNavItem.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  icon: PropTypes.node,
  isActive: PropTypes.bool.isRequired,
  notifications: PropTypes.number,
  hasSubMenu: PropTypes.bool,
  tabIndex: PropTypes.string,
};

VerticalNavItem.defaultProps = {
  className: "",
};

export default VerticalNavItem;
